import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexFieldValue } from 'src/app/shared/flex-fields/flex-field.model';

@Component({
    selector: 'app-flex-field-view',
    standalone: true,
    templateUrl: './flex-field-view.component.html',
    imports: [CommonModule]
})
export class FlexFieldViewComponent {

    @Input() flexFields: FlexFieldValue[] | null | undefined = [];
    @Input() containerClass = '';
    @Input() itemClass = '';
    @Input() isHeaderFields = true;

    readonly booleanDisplayMap = new Map<string | boolean, string>([
        [true, 'Yes'],
        ['true', 'Yes'],
        [false, 'No'],
        ['false', 'No']
    ]);

    get hasFields(): boolean {
        return (this.flexFields?.length ?? 0) > 0;
    }

    trackByFlexField(index: number, flex: FlexFieldValue): string | number {
        return flex.configId ?? flex.fieldName ?? index;
    }

    getLabel(flex: FlexFieldValue | undefined): string {
        if (!flex) {
            return '';
        }
        const label = flex.alternateFieldName?.trim();
        return label && label.length ? label : flex.fieldName;
    }

    formatValue(flex: FlexFieldValue | undefined): string {
        if (!flex) {
            return '-';
        }
        const value = flex.value;
        if (value === null || value === undefined || value === '') {
            return '-';
        }
        const type = (flex.dataType ?? '').toString().toUpperCase();
        if (type === 'BOOLEAN') {
            return this.booleanDisplayMap.get(value) ?? String(value);
        }
        return String(value);
    }
}
